export default {
  'profile.incomplete': 'Process incomplete​​​​​​​',
  'profile.navigateAway':
    'If you navigate away from the login process, you may need to restart the request and a new temporary password must be issued.',
  'profile.continue': 'Would you like to continue?'
};
